import PackageHeaderWrapper from "../shared/layout/HeadWrappers/PackageHeaderWrapper";
import PackageOverview from "./PackageOverview";
import PackageDetails from "./PackageDetails";
import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import DirectToConsumerService from "../../services/DirectToConsumerService";
import PackageData from "../../models/PackageData";
import { makeSerializable } from "../../utils/Utils";
import AppContext from "../../contexts/AppContext";
import routes from "../../constants/Routes";
import useRedirect from "../../hooks/useRedirect";
import CONSTANT from "../../constants/Constant";
import useD2C from "../../hooks/useD2C";
import useHandlePayment from "../../hooks/useHandlePayment";
import { toast } from "react-toastify";
import GLOBAL from "../../global";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";
import SignUp from "../sign-up/SignUp";
import SignIn from "../sign-in/SignIn";
import PreparationInstructionsModal from "../shared/MovementModal/PreparationInstructionsModal";
import PackageFooter from "./PackageFooter";
import './PackageDetailsPageWrapper.scss';

// Prevent unused-import lint warnings for components kept for commented code
void PackageDetails;
void PreparationInstructionsModal;

const RIGHT_SIDE_COMPONENT = {
    SIGN_UP: 'SIGN_UP',
    PACKAGE_OVERVIEW: 'PACKAGE_OVERVIEW',
    SIGN_IN: 'SIGN_IN'
}

const PackageDetailsPageWrapper = () => {
    const { authenticated } = useContext(AppContext);
    const location = useLocation();
    const history = useHistory();
    const { handleIsD2CEnabled } = useD2C();
    const { handlePay } = useHandlePayment();

    const [isLoadingNotification, setIsLoadingNotification] = useState(true);
    const [isError, setIsError] = useState(false);
    const [packageData, setPageData] = useState(makeSerializable(new PackageData()));
    const [isLoading, setIsLoading] = useState(false);
    const [rightSideComponent, setRightSideComponent] = useState(RIGHT_SIDE_COMPONENT.SIGN_UP);
    const [showPreparationInstructionModal, setShowPreparationInstructionModal] = useState(false);
    // used in commented code / reserved for future use
    void setShowPreparationInstructionModal;
    const [shouldShowHeaderAndRightSideComponent, setShouldShowHeaderAndRightSideComponent] = useState(true);
    const [emailToLoadInitiallyAtSignIn, setEmailToLoadInitiallyAtSignIn] = useState('');
    const [isPackageFooterViewable, setIsPackageFooterViewable] = useState(false);
    const { redirectKeepingQueryParams } = useRedirect();

    let query = new URLSearchParams(location?.search);
    const tenant = GLOBAL.TENANT;
    const { isPackageFooterEnable } = useTenantFeatures();
    const redirectToPayment = localStorage.getItem('redirectToPayment');

    useEffect(() => {
        setIsPackageFooterViewable(!!isPackageFooterEnable);
    }, [isPackageFooterEnable])

    useEffect(() => {
        if(authenticated && redirectToPayment === 'true') {
            localStorage.setItem('redirectToPayment', '');
            query.delete(CONSTANT.QUERY_PARAM.REDIRECT_TO_PAYMENT);
            handleOnClickGetStarted();
        }
    }, [authenticated, redirectToPayment])

    useEffect(() => {
        const isRedirected = handleIsD2CEnabled();
        if (isRedirected) return;

        if (query.get(CONSTANT.QUERY_PARAM.PLATFORM) && query.get(CONSTANT.QUERY_PARAM.PLATFORM).toLowerCase() === "mobileapp") {
            setShouldShowHeaderAndRightSideComponent(false);
        }
        handleGetPackageById();
    }, []);

    const handleGetPackageById = async () => {
        let packageId = query.get(CONSTANT.QUERY_PARAM.PACKAGE_ID) || '';
        let tempPackageDataMappedWithDTO = makeSerializable(new PackageData());

        if (packageId) {
            let tempPackageData = await DirectToConsumerService.getPackageById(
                {
                    GId: packageId,
                    Tenant: tenant
                });
            if(tempPackageData.success) {
                tempPackageDataMappedWithDTO = new PackageData(tempPackageData.data);
                setPageData(makeSerializable(tempPackageDataMappedWithDTO));
            } else {
                setIsError(true);
            }
            setIsLoadingNotification(false);

            if(tempPackageDataMappedWithDTO?.bodyRegionIds && tempPackageDataMappedWithDTO?.price && tempPackageDataMappedWithDTO?.title) {
                query.set(CONSTANT.QUERY_PARAM.BODY_REGION_IDS, tempPackageDataMappedWithDTO?.bodyRegionIds || '');
                query.set(CONSTANT.QUERY_PARAM.PRICE, tempPackageDataMappedWithDTO?.price || 0);
                query.set(CONSTANT.QUERY_PARAM.ASSESSMENT_NAME, tempPackageDataMappedWithDTO?.title || '');
                query.set(CONSTANT.QUERY_PARAM.REDIRECT_TO_PAYMENT, 'true');
                history.replace({ search: query.toString() });
            }
        }
    }

    const handleOnClickGetStarted = async () => {
        if(authenticated) {
            setIsLoading(true);
            let orderId = query.get(CONSTANT.QUERY_PARAM.ORDER_ID) || '';
            let packageId = query.get(CONSTANT.QUERY_PARAM.PACKAGE_ID) || '';
            let bodyRegionIdsFromUrl = query.get(CONSTANT.QUERY_PARAM.BODY_REGION_IDS) || '';
            let assessmentNameFromUrl = query.get(CONSTANT.QUERY_PARAM.ASSESSMENT_NAME) || '';

            if(!packageId || !bodyRegionIdsFromUrl || !assessmentNameFromUrl) {
                toast.error('Invalid url');
                return;
            }
            await handlePay(packageId, bodyRegionIdsFromUrl, assessmentNameFromUrl, orderId)
            setIsLoading(false);
        } else {
            redirectKeepingQueryParams(routes.signUp);
        }
    }

    return (
        <div className="package-details-root font-family-outfit">
            <div className="package-grid">
                <div className={`package-wrapper ${shouldShowHeaderAndRightSideComponent ? "" : " mmh-pt-0 "}`}>

                    {
                        shouldShowHeaderAndRightSideComponent
                            ? <PackageHeaderWrapper />
                            : ""
                    }

                    {
                        (isLoadingNotification || isError)
                            ?
                                (
                                    <div className="mmh-position-center">
                                        {isLoadingNotification && <i className="fa fa-spinner fa-spin mmh-font-primary mmh-font-size-4-rem"></i>}
                                        {isError && <div className="mmh-font-size-2-rem">Internal Server Error</div>}
                                    </div>
                             )
                             : (
                                <div className="package-portlet bg-color-light-gray-1">
                                    <div className={`package-portlet__body mmh-d-flex mmh-justify-center mmh-align-center mmh-mt-xl-0`}>
                                        <div className={`package-row font-family-outfit package-justify-center`}>
                                             {/*<div className="row font-family-outfit g-5 justify-content-center">*/}
                                             {/*    <div className={` p-0 ${!shouldShowHeaderAndRightSideComponent ? ' col-12 ' : ' col-md-12 col-lg-7 col-xl-6 '}`}>*/}
                                                <div className={`content-col ${!shouldShowHeaderAndRightSideComponent ? ' order-mobile-secondary ' : ''}`}>
                                                    <div
                                                        // className="padding-1-5rem"
                                                        className="mmh-mr-2 package-details-content"
                                                        dangerouslySetInnerHTML={{ __html: packageData?.packageDetails || '' }}
                                                    />

                                                    {/*<h4 className="color-primary mt-4">*/}
                                                    {/*    <span className="text-underline cursor-pointer" onClick={() => setShowPreparationInstructionModal(true)}>Preparation Instructions</span>*/}
                                                    {/*    /!*to find out why good posture is important!*!/*/}
                                                    {/*</h4>*/}

                                                    {/*<PackageDetails*/}
                                                    {/*    title={packageData?.title || ''}*/}
                                                    {/*    price={packageData?.price || 0}*/}
                                                    {/*/>*/}

                                                    {/*Package footer*/}
                                                    {
                                                        isPackageFooterViewable && <PackageFooter />
                                                    }
                                                </div>

                                               {
                                                   shouldShowHeaderAndRightSideComponent
                                                   ?
                                                       (
                                                           <div className="right-col height-fit-content">

                                                               {
                                                                   authenticated
                                                                       ? (
                                                                           <div className={`${showPreparationInstructionModal ? " position-relative " : " package-overview-fixed " } mmh-max-height-85-vh mmh-overflow-y-auto `}>
                                                                                <PackageOverview
                                                                                    title={packageData?.title || ''}
                                                                                    iconSrc={packageData?.imageUrl || ''}
                                                                                    price={packageData?.price || 0}
                                                                                    basePrice={packageData?.basePrice || 0}
                                                                                    shortDescription={packageData?.shortDescription || ''}
                                                                                    onClickGetStarted={handleOnClickGetStarted}
                                                                                    loading={isLoading}
                                                                                />
                                                                           </div>
                                                                       )
                                                                       : (
                                                                           <div className={`${showPreparationInstructionModal ? " position-relative " : " package-overview-fixed " } mmh-max-height-90-vh mmh-overflow-y-auto `}>
                                                                               {rightSideComponent === RIGHT_SIDE_COMPONENT.SIGN_UP && (
                                                                                   <SignUp
                                                                                       onClickRedirectToSignIn={() => setRightSideComponent(RIGHT_SIDE_COMPONENT.SIGN_IN)}
                                                                                       setEmailToLoadInitiallyAtSignIn={setEmailToLoadInitiallyAtSignIn}
                                                                                   />
                                                                               )}
                                                                               {rightSideComponent === RIGHT_SIDE_COMPONENT.SIGN_IN && (
                                                                                   <SignIn
                                                                                       onClickRedirectToSignUp={() => setRightSideComponent(RIGHT_SIDE_COMPONENT.SIGN_UP)}
                                                                                       emailToLoadInitially={emailToLoadInitiallyAtSignIn}
                                                                                       setEmailToLoadInitiallyAtSignIn={setEmailToLoadInitiallyAtSignIn}
                                                                                       isFromPackageDetailsPage={true}
                                                                                   />
                                                                               )}
                                                                           </div>
                                                                       )
                                                               }
                                                           </div>
                                                       )
                                                   : (
                                                       // For mobile app
                                                       <div className="right-col mobile-col height-fit-content order-mobile-primary mmh-d-flex mmh-align-center mmh-justify-center">
                                                           <PackageOverview
                                                               title={packageData?.title || ''}
                                                               iconSrc={packageData?.imageUrl || ''}
                                                               price={packageData?.price || 0}
                                                               basePrice={packageData?.basePrice || 0}
                                                               shortDescription={packageData?.shortDescription || ''}
                                                               onClickGetStarted={handleOnClickGetStarted}
                                                               loading={isLoading}
                                                               isFromMobileApp={true}
                                                           />
                                                       </div>
                                                   )
                                               }
                                        </div>
                                    </div>
                                </div>
                            )
                    }
                </div>
            </div>

            {/*{showPreparationInstructionModal && (*/}
            {/*    // <PackageIntroVideoModal*/}
            {/*    //     onClose={() => setShowVideoModal(false)}*/}
            {/*    //     show={showVideoModal}*/}
            {/*    // />*/}
            {/*    <PreparationInstructionsModal*/}
            {/*        onClose={() => setShowPreparationInstructionModal(false)}*/}
            {/*    />*/}
            {/*)}*/}
        </div>
    )
}

export default PackageDetailsPageWrapper;
